import {
  userActionInterceptor,
  staticIdDecorator,
} from '../socketIO/user.action.interceptor';
import layerManager from '../layer.manager';
import store from '../../store/index';
import * as layerNames from '../layerName';
import eventBus from '@/services/eventBus.service';
import { userSeriesCarLayer } from '../../services/selectSeriesCar.service';
@staticIdDecorator('PriceListActionSync')
class PriceListActionSync {
  @userActionInterceptor()
  showDlrQuotationFn() {
    layerManager.openPriceList({
      propsData: {
        isOpenDlrQuotation: true,
        layerName: layerNames.PRICE_LIST,
      },
    });
  }
  @userActionInterceptor({ methodName: 'openMask' })
  openPriceListWeChatPhoneOrder(tip) {
    console.log('openPriceListWeChatPhoneOrder', tip);
  }
  openMask(tip) {
    console.log('openMask', tip);
    layerManager.open(layerNames.TRANSPARENT_MASK, {
      propsData: { tips: tip },
    });
  }
  @userActionInterceptor()
  openSeriesLay(seriesId, specId) {
    layerManager.openPriceListSeries({
      propsData: {
        seriesId: seriesId,
        isNeedOpenSpecList: true,
        layerName2: layerNames.PRICELIST_SPECLIST_LAYER,
        layerName: layerNames.PRICELIST_SERIES_LIST,
        onSelectItem: function (data) {
          console.log(data);
        },
        specId: specId,
        // 这里关闭车型页面之后的操作
        onSelectSpecItem: function (data) {
          const { selectOneCar } = userSeriesCarLayer();
          selectOneCar(data);
          store.commit('dealer/setSalesSeriesId', data.seriesId);
        },
      },
    });
  }
  @userActionInterceptor()
  changePayType(type) {
    store.commit('priceList/setPayType', type);
  }
  @userActionInterceptor()
  changeMoneyType(obj) {
    store.commit('priceList/setResetInfo', {
      payType: obj.resetInfo.payType,
      prepaymentType:
        obj.type === 'prepaymentType'
          ? obj.value
          : obj.resetInfo.prepaymentType,
      loanTypeForYear:
        obj.type === 'loanTypeForYear'
          ? obj.value
          : obj.resetInfo.loanTypeForYear,
    });
    store.dispatch('priceList/getPriceListAction', {
      cityId: obj.cityId,
      specId: obj.specInfo.SpecId,
      minPrice: obj.specInfo.NewsPrice || obj.specInfo.MinPrice,
      carPrice: obj.carPrice,
      prepaymentType:
        obj.type === 'prepaymentType'
          ? obj.value
          : obj.resetInfo.prepaymentType,
      loanTypeForYear:
        obj.type === 'loanTypeForYear'
          ? obj.value
          : obj.resetInfo.loanTypeForYear,
    });
  }
  @userActionInterceptor()
  getPriceList(obj) {
    const standardPrice = obj.specInfo.NewsPrice || obj.specInfo.MinPrice;
    const maxAmount = standardPrice * 1.2;
    const minAmount = standardPrice * 0.4;
    if (obj.value > maxAmount) {
      layerManager.toast({ message: '您填写的裸车价金额过高！请确认！' }, 1000);
      return;
    }
    if (obj.value < minAmount) {
      layerManager.toast({ message: '您填写的裸车价金额过低！请确认！' }, 1000);
      return;
    }
    store.dispatch('priceList/getPriceListAction', {
      cityId: obj.cityId,
      specId: obj.specInfo.SpecId,
      minPrice: obj.specInfo.NewsPrice || obj.specInfo.MinPrice,
      carPrice: obj.value,
      prepaymentType: obj.resetInfo.prepaymentType,
      loanTypeForYear: obj.resetInfo.loanTypeForYear,
    });
  }
  @userActionInterceptor()
  closeLay() {
    eventBus.$emit('closePriceListLay', {
      promotionId: this.promotionId,
      redPacketsTypeId: this.redPacketsTypeId,
      typeId: this.typeId,
    });
  }
  @userActionInterceptor()
  changeShowType(type) {
    eventBus.$emit('changeShowType', type);
  }
}
const priceListActionSync = new PriceListActionSync();
export default priceListActionSync;
